import { Alert, Snackbar } from '@material-ui/core';
import React from 'react';
import { observer } from 'mobx-react';

const GenericSnack = observer(({snackStore}) => {
  return (
    <Snackbar open={snackStore.snack.open} autoHideDuration={5000} onClose={snackStore.handleSnackClose}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert onClose={() => snackStore.handleSnackClose(null, null)} severity={snackStore.snack.severity}>
        {snackStore.snack.message}
      </Alert>
    </Snackbar>
  );
});

export default GenericSnack;
